import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `edit`; old bookmarks and links still land here.
export const Route = createFileRoute('/_authenticated/templates/email/$emailTemplateId/update')({
    // Only redirects: `edit` checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/templates/email/$emailTemplateId/edit',
            params: { emailTemplateId: params.emailTemplateId },
            search: true,
            replace: true,
        });
    },
});
